import { render } from "./PredictionsPage.vue?vue&type=template&id=754d708a&scoped=true"
import script from "./PredictionsPage.vue?vue&type=script&lang=js"
export * from "./PredictionsPage.vue?vue&type=script&lang=js"

import "./PredictionsPage.vue?vue&type=style&index=0&id=754d708a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754d708a"]])

export default __exports__